/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ToastConfig } from './toastConfig';
import { EmailFailedData } from './emailFailedData';


/**
 * WebSocket notification for email failed.
 */
import {ValidatorFn, Validators} from "@angular/forms";

export interface EmailFailedNotification { 
    /**
     * Always \'email.failed\'
     */
    readonly type: string;
    data: EmailFailedData;
    toast?: ToastConfig | null;
}
export const EmailFailedNotification_type_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const EmailFailedNotification_data_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const EmailFailedNotification_toast_Validators: ValidatorFn[] =
    [ ];


